import * as React from 'react';
import './TeamChat.css';
import { AppStore } from '../../stores';
import { inject, observer } from 'mobx-react';
import Header from '../header/Header';
import LogoBar from '../logoBar/LogoBar';
import TeamChatService from '../../services/TeamChatService';
import { ITeamChat, ITeamChatMessage } from '../../interfaces/ITeamChat';
import Moment from 'react-moment';
import ProductService from '../../services/ProductService';
import { FilePicker } from '../UI/filePicker/FilePicker';
import AdminService from '../../services/AdminService';
import { Helper } from '../../services/HelperService';

export interface IProps {
  appStore?: AppStore;
}

export interface IState {
  containerWidth?: number;
  messages: ITeamChatMessage[];
  availableTeamChats: ITeamChat[]
  selectedTeamChatId?: string;
  message?: string;
  messageIdToEdit?: string;
  editingContent?: string;
  editingImages: string[];
  editingVideos: string[];
  loading?: boolean;
  showingAdditionalTools?: boolean;
  showingVideoTool?: boolean;
  videoUrlInput?: string;
  images: string[];
  videos: string[];
  imageToEdit?: string;
  imageToView?: string;
}

@inject('appStore')
@observer
export default class TeamChat extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      containerWidth: 0,
      messages: [],
      availableTeamChats: [],
      loading: false,
      images: [],
      videos: [],
      editingImages: [],
      editingVideos: []
    }
  }

  public componentDidMount(): void {
    if (this.props.appStore) {
      this.props.appStore!.selectedTab = 9;
    }
    // Resize
    window.addEventListener('resize', () => this.resize());
    this.getTeamChats();
    this.resize();
    setTimeout(() => {
      this.resize();
    }, 0);
    try {
      var resizeObserver = new ResizeObserver(() => {
        this.resize();
      });
      resizeObserver.observe(document.getElementById(`TeamChat`)!);
    } catch {
      this.resize();
    }
  }

  private getTeamChats(): void {
    this.setState({ loading: true });
    TeamChatService.getTeamChats().then((teamChats) => {
      teamChats = teamChats?.filter((tc) => tc.enabled);
      if (teamChats?.length > 0) {
        // Admin user
        if (this.props.appStore?.user?.userType === "admin") {
          teamChats.forEach((teamChat, index) => {
            this.setState({ availableTeamChats: [...this.state.availableTeamChats, teamChat], selectedTeamChatId: index === 0 ? teamChat.teamId : this.state.selectedTeamChatId }, () => {
              if (index === 0) {
                this.getTeamChat();
              }
              if (index === teamChats.length - 1) {
                this.setState({ loading: false });
              }
            });
          });
        } else {
          // Regular user
          teamChats.forEach((teamChat, index) => {
            // Check if user is member of team productId: string, user: string, accessPeriod: any, team: string
            ProductService.hasUserAccessToProductAndTeam(teamChat.productId, this.props.appStore?.user?.username || '', undefined, teamChat.teamId).then((hasAccess) => {
              if (hasAccess) {
                this.setState({ availableTeamChats: [...this.state.availableTeamChats, teamChat] }, () => {
                  if (this.state.availableTeamChats.length === 1) {
                    this.setState({ selectedTeamChatId: teamChat.teamId }, () => this.getTeamChat());
                  }
                });
              }
              if (index === teamChats.length - 1) {
                this.setState({ loading: false });
              }
            });
          });
        }
      } else {
        this.setState({ loading: false });
      }
    });
  }

  private getTeamChat(): void {
    if (!this.state.selectedTeamChatId) {
      console.error('No team chat selected');
      return;
    }
    TeamChatService.getTeamChatMessagesForChat(this.state.selectedTeamChatId).then((messages) => {
      this.setState({
        messages
      });
    });
  }

  private resize(): void {
    const programsContainer = document.getElementById("TeamChat");
    const padding = this.props.appStore?.isMobile ? 40 : 80;
    if (programsContainer?.clientWidth) {
      this.setState({ containerWidth: programsContainer.clientWidth - padding }, () => this.forceUpdate());
    }
  }

  render() {
    let top = this.props.appStore?.isMobile && window.platform !== "ios" ? 0 : 50;
    let height = this.props.appStore?.isMobile ? `calc(100% - ${this.props.appStore?.isMobile && window.platform !== "ios" ? 80 : 130}px)` : (this.props.appStore?.podcastToPlay ? `calc(100% - ${this.props.appStore?.isMobile && window.platform !== "ios" ? 101 : 151}px)` : `calc(100% - ${this.props.appStore?.isMobile && window.platform !== "ios" ? 0 : 50}px)`);
    if (this.props.appStore?.isIpad) {
      height = this.props.appStore?.podcastToPlay ? `calc(100% - 201px)` : `calc(100% - 100px)`;
      top = 100;
    }
    return (
      <div
        id="TeamChat"
        className='teamChat'
        style={{
          top: top,
          left: this.props.appStore?.isMobile ? 0 : 250,
          width: this.props.appStore?.isMobile ? "100vw" : "calc(100vw - 250px)",
          height: height
        }}
      >
        {location.href.indexOf("mindPaperId") == -1 && this.props.appStore?.user && this.props.appStore?.isMobile && !window.location.pathname.includes("/enneagrammy") &&
          <LogoBar />
        }
        <Header
          headline={(window as any).loc?.strings?.teamChatHeader || 'Team Chat'}
          headlineStyle={{
            width: "calc(100% - 200px)"
          }}
        >
          {this.state.loading ?
            <div>Loading...</div>
            :
            (this.state.availableTeamChats?.length > 1 &&
              <select
                name="cars"
                id="cars"
                placeholder="Vælg hold"
                value={this.state.selectedTeamChatId || ''}
                style={{
                  right: 585,
                  height: 35,
                  fontSize: 14,
                  lineHeight: '35px',
                  padding: '0 10px',
                  borderRadius: 5,
                  border: '1px solid #CCC',
                  backgroundColor: '#FFF',
                  color: '#000',
                  maxWidth: 200
                }}
                onChange={(selectedOption: any) => {
                  this.setState({ selectedTeamChatId: selectedOption.target.value }, () => this.getTeamChat());
                }}
              >
                {this.state.availableTeamChats?.map((teamChat: ITeamChat) => (
                  <option
                    key={teamChat.objectId}
                    value={teamChat.teamId}
                  >
                    {`${teamChat?.productName} (Hold ${teamChat?.teamId})`}
                  </option>
                ))}
              </select>
            )
          }
        </Header>
        {this.state.loading ?
          <div className='messagesContainer'>
            {window.loc.strings.loading}
          </div>
          :
          (this.state.availableTeamChats?.length > 0 ?
            <>
              <div
                className='messagesContainer'
              >
                {this.state.messages.length === 0 &&
                  <div className='noMessagesPlaceholder'>
                    {window.loc.strings.teamChatNoMessages}
                  </div>
                }
                {this.state.messages.map((message: ITeamChatMessage) => (
                  <div
                    key={message.objectId}
                    className='messageCardWrapper'
                    style={{
                    }}
                  >
                    <Moment fromNow className='messageTimeAgo' locale="da">{message.createdAt}</Moment>
                    <div
                      className='messageCard'
                      style={{
                        backgroundColor: message.userId === this.props.appStore?.user?.id ? '#D1E7FF' : '#F1F1F1',
                        alignSelf: message.userId === this.props.appStore?.user?.id ? 'flex-end' : 'flex-start'
                      }}
                    >
                      <div className='messageHeader'>
                        <span className='username'>{message.updatedAt === message.createdAt ? message.username : `${message.username} (edited)`}</span>
                        {message.userId === this.props.appStore?.user?.id &&
                          <button
                            className='editButton'
                            onClick={() => {
                              this.setState({ messageIdToEdit: message.objectId, editingContent: message.content, editingImages: message.images ? [...message.images] : [], editingVideos: message.videos ? [...message.videos] : [] });
                            }}
                          />
                        }
                      </div>
                      <div className='messageContent'>
                        {this.state.messageIdToEdit === message.objectId && message.userId === this.props.appStore?.user?.id ?
                          <div>
                            <textarea
                              className='editMessageInput'
                              value={this.state.editingContent}
                              onChange={(event: any) => this.setState({ editingContent: event.target.value })}
                            />
                            {this.state.editingImages.length > 0 &&
                              <div className='pendingImagesContainer pendingImagesContainerInline'>
                                {this.state.editingImages.map((image: string, index: number) => (
                                  <div key={`editingImage_${index}`} className='pendingImageWrapper'>
                                    <img className='pendingImage' src={image} alt="" />
                                    <button
                                      className='removePendingImageButton'
                                      onClick={() => {
                                        const editingImages = [...this.state.editingImages];
                                        editingImages.splice(index, 1);
                                        this.setState({ editingImages });
                                      }}
                                    />
                                  </div>
                                ))}
                              </div>
                            }
                            <button
                              className='addImageButton addImageButtonInline'
                              onClick={() => {
                                this.setState({ showingAdditionalTools: true });
                              }}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                <path d="M18.75 4C20.5449 4 22 5.45507 22 7.25V18.75C22 20.5449 20.5449 22 18.75 22H7.25C5.45507 22 4 20.5449 4 18.75V12.5019C4.47425 12.6996 4.97687 12.8428 5.50009 12.9236L5.5 18.75C5.5 18.9584 5.53643 19.1583 5.60326 19.3437L11.4258 13.643C12.2589 12.8273 13.5675 12.7885 14.4458 13.5266L14.5742 13.6431L20.3964 19.3447C20.4634 19.159 20.5 18.9588 20.5 18.75V7.25C20.5 6.2835 19.7165 5.5 18.75 5.5L12.9236 5.50009C12.8428 4.97687 12.6996 4.47425 12.5019 4H18.75ZM12.5588 14.644L12.4752 14.7148L6.66845 20.4011C6.8504 20.4651 7.04613 20.5 7.25 20.5H18.75C18.9535 20.5 19.1489 20.4653 19.3305 20.4014L13.5247 14.7148C13.2596 14.4553 12.8501 14.4316 12.5588 14.644ZM16.2521 7.5C17.4959 7.5 18.5042 8.50831 18.5042 9.75212C18.5042 10.9959 17.4959 12.0042 16.2521 12.0042C15.0083 12.0042 14 10.9959 14 9.75212C14 8.50831 15.0083 7.5 16.2521 7.5ZM6.5 1C9.53757 1 12 3.46243 12 6.5C12 9.53757 9.53757 12 6.5 12C3.46243 12 1 9.53757 1 6.5C1 3.46243 3.46243 1 6.5 1ZM16.2521 9C15.8367 9 15.5 9.33673 15.5 9.75212C15.5 10.1675 15.8367 10.5042 16.2521 10.5042C16.6675 10.5042 17.0042 10.1675 17.0042 9.75212C17.0042 9.33673 16.6675 9 16.2521 9ZM6.5 2.99923L6.41012 3.00729C6.20603 3.04433 6.0451 3.20527 6.00806 3.40936L6 3.49923L5.99965 5.99923L3.49765 6L3.40777 6.00806C3.20368 6.0451 3.04275 6.20603 3.00571 6.41012L2.99765 6.5L3.00571 6.58988C3.04275 6.79397 3.20368 6.9549 3.40777 6.99194L3.49765 7L6.00065 6.99923L6.00111 9.50348L6.00916 9.59336C6.04621 9.79745 6.20714 9.95839 6.41123 9.99543L6.50111 10.0035L6.59098 9.99543C6.79508 9.95839 6.95601 9.79745 6.99305 9.59336L7.00111 9.50348L7.00065 6.99923L9.50457 7L9.59444 6.99194C9.79853 6.9549 9.95947 6.79397 9.99651 6.58988L10.0046 6.5L9.99651 6.41012C9.95947 6.20603 9.79853 6.0451 9.59444 6.00806L9.50457 6L6.99965 5.99923L7 3.49923L6.99194 3.40936C6.9549 3.20527 6.79397 3.04433 6.58988 3.00729L6.5 2.99923Z" fill="#7a12d4" />
                              </svg>
                            </button>
                            {this.state.editingVideos.length > 0 &&
                              <div className='pendingVideosContainer pendingVideosContainerInline'>
                                {this.state.editingVideos.map((video: string, index: number) => (
                                  <div key={`editingVideo_${index}`} className='pendingVideoWrapper'>
                                    <span className='pendingVideoLabel'>{video}</span>
                                    <button
                                      className='removePendingImageButton'
                                      onClick={() => {
                                        const editingVideos = [...this.state.editingVideos];
                                        editingVideos.splice(index, 1);
                                        this.setState({ editingVideos });
                                      }}
                                    />
                                  </div>
                                ))}
                              </div>
                            }
                            <button
                              className='addVideoButton addVideoButtonInline'
                              onClick={() => {
                                this.setState({ showingVideoTool: true });
                              }}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                <path d="M4.75 4C3.2312 4 2 5.2312 2 6.75V17.25C2 18.7688 3.2312 20 4.75 20H14.25C15.7688 20 17 18.7688 17 17.25V6.75C17 5.2312 15.7688 4 14.25 4H4.75ZM3.5 6.75C3.5 6.05964 4.05964 5.5 4.75 5.5H14.25C14.9404 5.5 15.5 6.05964 15.5 6.75V17.25C15.5 17.9404 14.9404 18.5 14.25 18.5H4.75C4.05964 18.5 3.5 17.9404 3.5 17.25V6.75ZM18.5 9.6584L21.1197 7.6892C21.6357 7.30162 22.3703 7.42118 22.7378 7.94739C22.9078 8.19151 23 8.48338 23 8.78257V15.2174C23 15.8629 22.4855 16.4152 21.8237 16.4692C21.5533 16.4913 21.283 16.4218 21.0559 16.2718L18.5 14.5836V9.6584Z" fill="#7a12d4" />
                              </svg>
                            </button>
                            <button
                              className='saveEditButton'
                              disabled={!this.state.editingContent || this.state.editingContent.trim() === ""}
                              onClick={() => {
                                if (message.objectId && this.state.editingContent) {
                                  TeamChatService.updateTeamChatMessage(message.objectId, this.state.editingContent, this.state.editingImages.length > 0 ? this.state.editingImages : undefined, this.state.editingVideos.length > 0 ? this.state.editingVideos : undefined).then(() => {
                                    this.setState({ messageIdToEdit: undefined, editingContent: "", editingImages: [], editingVideos: [] });
                                    this.getTeamChat();
                                  });
                                }
                              }}
                            >
                              {window.loc.strings.teamChatUpdateMessageButton}
                            </button>
                            <button
                              className='cancelEditButton'
                              onClick={() => {
                                this.setState({ messageIdToEdit: undefined, editingContent: "", editingImages: [], editingVideos: [] });
                              }}
                            >
                              {window.loc.strings.teamChatCancelMessageButton}
                            </button>
                            <button
                              className='deleteEditButton'
                              onClick={() => {
                                if (message.objectId) {
                                  TeamChatService.deleteTeamChatMessage(message.objectId).then(() => {
                                    this.setState({ messageIdToEdit: undefined, editingContent: "", editingImages: [], editingVideos: [] });
                                    this.getTeamChat();
                                  });
                                }
                              }}
                            >
                              {window.loc.strings.teamChatDeleteMessageButton}
                            </button>
                          </div>
                          :
                          message.content}
                      </div>
                      {this.state.messageIdToEdit !== message.objectId && message.images && message.images.length > 0 &&
                        <div className='messageImages'>
                          {message.images.map((image: string, index: number) => (
                            <img
                              key={`${message.objectId}_image_${index}`}
                              className='messageImage'
                              src={image}
                              alt=""
                              onClick={() => {
                                this.setState({ imageToView: image });
                              }}
                            />
                          ))}
                        </div>
                      }
                      {this.state.messageIdToEdit !== message.objectId && message.videos && message.videos.length > 0 &&
                        <div className='messageVideos'>
                          {message.videos.map((video: string, index: number) => (
                            <iframe
                              key={`${message.objectId}_video_${index}`}
                              className='messageVideo'
                              src={Helper.convertUrlToEmbedUrl(video)}
                              frameBorder="0"
                              allow="autoplay; fullscreen"
                              allowFullScreen
                            />
                          ))}
                        </div>
                      }
                    </div>
                  </div>
                ))}
              </div>
              <textarea
                className='teamChatMessageInput'
                placeholder={window.loc.strings.teamChatMessagePlaceholder}
                onChange={(event: any) => this.setState({ message: event.target.value })}
                value={this.state.message}
              />
              {this.state.images.length > 0 &&
                <div className='pendingImagesContainer'>
                  {this.state.images.map((image: string, index: number) => (
                    <div key={`pendingImage_${index}`} className='pendingImageWrapper'>
                      <img className='pendingImage' src={image} alt="" />
                      <button
                        className='removePendingImageButton'
                        onClick={() => {
                          const images = [...this.state.images];
                          images.splice(index, 1);
                          this.setState({ images });
                        }}
                      />
                    </div>
                  ))}
                </div>
              }
              {this.state.videos.length > 0 &&
                <div className='pendingVideosContainer'>
                  {this.state.videos.map((video: string, index: number) => (
                    <div key={`pendingVideo_${index}`} className='pendingVideoWrapper'>
                      <span className='pendingVideoLabel'>{video}</span>
                      <button
                        className='removePendingImageButton'
                        onClick={() => {
                          const videos = [...this.state.videos];
                          videos.splice(index, 1);
                          this.setState({ videos });
                        }}
                      />
                    </div>
                  ))}
                </div>
              }
              {this.state.showingAdditionalTools &&
                <div className='addImagePopup'>
                  <div
                    className='addImagePopupBackground'
                    onClick={() => {
                      this.setState({ showingAdditionalTools: false });
                    }}
                  />
                  <div className='addImagePopupBox'>
                    <div
                      className='closeButton'
                      onClick={() => {
                        this.setState({ showingAdditionalTools: false });
                      }}
                    />
                    <h3>{window.loc.strings.teamChatAddImageHeader || 'Tilføj billede'}</h3>
                    <FilePicker
                      url={this.state.imageToEdit ?? ""}
                      placeholderText={"Indsæt et link eller upload en fil..."}
                      inputWidth={this.props.appStore?.isMobile ? "79%" : "87%"}
                      onChange={(url: string) => {
                        if (this.state.messageIdToEdit) {
                          this.setState({ editingImages: [...this.state.editingImages, url], showingAdditionalTools: false });
                        } else {
                          this.setState({ images: [...this.state.images, url], showingAdditionalTools: false });
                        }
                        if (url && url != undefined && url !== "" && url.indexOf("mindjuice.herokuapp.com/parse/files") !== -1) {
                          const splittedUrl = url.split(".");
                          let fileType = splittedUrl[splittedUrl.length - 1];
                          AdminService.addFile({
                            url: url,
                            fileType: fileType,
                            product: undefined,
                            team: undefined,
                            type: "teamChatImage"
                          });
                        }
                      }}
                    />
                  </div>
                </div>
              }
              {this.state.showingVideoTool &&
                <div className='addImagePopup'>
                  <div
                    className='addImagePopupBackground'
                    onClick={() => {
                      this.setState({ showingVideoTool: false, videoUrlInput: "" });
                    }}
                  />
                  <div className='addImagePopupBox'>
                    <div
                      className='closeButton'
                      onClick={() => {
                        this.setState({ showingVideoTool: false, videoUrlInput: "" });
                      }}
                    />
                    <h3>{window.loc.strings.teamChatAddVideoHeader || 'Tilføj video'}</h3>
                    <input
                      type="text"
                      className='videoUrlInput'
                      placeholder={"Indsæt Vimeo eller YouTube link..."}
                      value={this.state.videoUrlInput ?? ""}
                      onChange={(event: any) => this.setState({ videoUrlInput: event.target.value })}
                      onKeyDown={(event: React.KeyboardEvent) => {
                        if (event.key === "Enter" && this.state.videoUrlInput && this.state.videoUrlInput.trim() !== "") {
                          if (this.state.messageIdToEdit) {
                            this.setState({ editingVideos: [...this.state.editingVideos, this.state.videoUrlInput], showingVideoTool: false, videoUrlInput: "" });
                          } else {
                            this.setState({ videos: [...this.state.videos, this.state.videoUrlInput], showingVideoTool: false, videoUrlInput: "" });
                          }
                        }
                      }}
                    />
                    <button
                      className='addVideoConfirmButton'
                      disabled={!this.state.videoUrlInput || this.state.videoUrlInput.trim() === ""}
                      onClick={() => {
                        if (this.state.videoUrlInput && this.state.videoUrlInput.trim() !== "") {
                          if (this.state.messageIdToEdit) {
                            this.setState({ editingVideos: [...this.state.editingVideos, this.state.videoUrlInput], showingVideoTool: false, videoUrlInput: "" });
                          } else {
                            this.setState({ videos: [...this.state.videos, this.state.videoUrlInput], showingVideoTool: false, videoUrlInput: "" });
                          }
                        }
                      }}
                    >
                      {window.loc.strings.teamChatAddVideoButton || 'Tilføj'}
                    </button>
                  </div>
                </div>
              }
              {this.state.imageToView &&
                <div className='viewImagePopup'>
                  <div
                    className='viewImagePopupBackground'
                    onClick={() => {
                      this.setState({ imageToView: undefined });
                    }}
                  />
                  <div className='viewImagePopupBox'>
                    <div
                      className='closeButton'
                      onClick={() => {
                        this.setState({ imageToView: undefined });
                      }}
                    />
                    <img className='viewImagePopupImage' src={this.state.imageToView} alt="" />
                  </div>
                </div>
              }
              <div className='composerToolbar'>
                <button
                  className='addImageButton'
                  onClick={() => {
                    this.setState({ showingAdditionalTools: !this.state.showingAdditionalTools });
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M18.75 4C20.5449 4 22 5.45507 22 7.25V18.75C22 20.5449 20.5449 22 18.75 22H7.25C5.45507 22 4 20.5449 4 18.75V12.5019C4.47425 12.6996 4.97687 12.8428 5.50009 12.9236L5.5 18.75C5.5 18.9584 5.53643 19.1583 5.60326 19.3437L11.4258 13.643C12.2589 12.8273 13.5675 12.7885 14.4458 13.5266L14.5742 13.6431L20.3964 19.3447C20.4634 19.159 20.5 18.9588 20.5 18.75V7.25C20.5 6.2835 19.7165 5.5 18.75 5.5L12.9236 5.50009C12.8428 4.97687 12.6996 4.47425 12.5019 4H18.75ZM12.5588 14.644L12.4752 14.7148L6.66845 20.4011C6.8504 20.4651 7.04613 20.5 7.25 20.5H18.75C18.9535 20.5 19.1489 20.4653 19.3305 20.4014L13.5247 14.7148C13.2596 14.4553 12.8501 14.4316 12.5588 14.644ZM16.2521 7.5C17.4959 7.5 18.5042 8.50831 18.5042 9.75212C18.5042 10.9959 17.4959 12.0042 16.2521 12.0042C15.0083 12.0042 14 10.9959 14 9.75212C14 8.50831 15.0083 7.5 16.2521 7.5ZM6.5 1C9.53757 1 12 3.46243 12 6.5C12 9.53757 9.53757 12 6.5 12C3.46243 12 1 9.53757 1 6.5C1 3.46243 3.46243 1 6.5 1ZM16.2521 9C15.8367 9 15.5 9.33673 15.5 9.75212C15.5 10.1675 15.8367 10.5042 16.2521 10.5042C16.6675 10.5042 17.0042 10.1675 17.0042 9.75212C17.0042 9.33673 16.6675 9 16.2521 9ZM6.5 2.99923L6.41012 3.00729C6.20603 3.04433 6.0451 3.20527 6.00806 3.40936L6 3.49923L5.99965 5.99923L3.49765 6L3.40777 6.00806C3.20368 6.0451 3.04275 6.20603 3.00571 6.41012L2.99765 6.5L3.00571 6.58988C3.04275 6.79397 3.20368 6.9549 3.40777 6.99194L3.49765 7L6.00065 6.99923L6.00111 9.50348L6.00916 9.59336C6.04621 9.79745 6.20714 9.95839 6.41123 9.99543L6.50111 10.0035L6.59098 9.99543C6.79508 9.95839 6.95601 9.79745 6.99305 9.59336L7.00111 9.50348L7.00065 6.99923L9.50457 7L9.59444 6.99194C9.79853 6.9549 9.95947 6.79397 9.99651 6.58988L10.0046 6.5L9.99651 6.41012C9.95947 6.20603 9.79853 6.0451 9.59444 6.00806L9.50457 6L6.99965 5.99923L7 3.49923L6.99194 3.40936C6.9549 3.20527 6.79397 3.04433 6.58988 3.00729L6.5 2.99923Z" fill="#7a12d4" />
                  </svg>
                </button>
                <button
                  className='addVideoButton'
                  onClick={() => {
                    this.setState({ showingVideoTool: !this.state.showingVideoTool });
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M4.75 4C3.2312 4 2 5.2312 2 6.75V17.25C2 18.7688 3.2312 20 4.75 20H14.25C15.7688 20 17 18.7688 17 17.25V6.75C17 5.2312 15.7688 4 14.25 4H4.75ZM3.5 6.75C3.5 6.05964 4.05964 5.5 4.75 5.5H14.25C14.9404 5.5 15.5 6.05964 15.5 6.75V17.25C15.5 17.9404 14.9404 18.5 14.25 18.5H4.75C4.05964 18.5 3.5 17.9404 3.5 17.25V6.75ZM18.5 9.6584L21.1197 7.6892C21.6357 7.30162 22.3703 7.42118 22.7378 7.94739C22.9078 8.19151 23 8.48338 23 8.78257V15.2174C23 15.8629 22.4855 16.4152 21.8237 16.4692C21.5533 16.4913 21.283 16.4218 21.0559 16.2718L18.5 14.5836V9.6584Z" fill="#7a12d4" />
                  </svg>
                </button>
                <button
                  className='sendMessageButton'
                  disabled={!this.state.message || this.state.message.trim() === ""}
                  onClick={() => {
                    if (this.state.selectedTeamChatId && this.state.message && this.props.appStore?.user?.id && this.props.appStore?.user?.name) {
                      TeamChatService.createTeamChatMessage({
                        teamChatId: this.state.selectedTeamChatId,
                        userId: this.props.appStore!.user.id,
                        username: this.props.appStore!.user.name,
                        content: this.state.message,
                        images: this.state.images.length > 0 ? this.state.images : undefined,
                        videos: this.state.videos.length > 0 ? this.state.videos : undefined
                      }).then(() => {
                        this.getTeamChat();
                        this.setState({ message: '', images: [], videos: [] });
                      });
                    }
                  }}
                >
                  {window.loc.strings.teamChatSendMessageButton}
                </button>
              </div>
            </>


            :
            <div className='messagesContainer'>
              {window.loc.strings.teamChatNoAvailableTeamChats}
            </div>)
        }
      </div>
    );
  }

  public componentWillUnmount(): void {
    window.removeEventListener('resize', () => this.resize());
  }

}